import type { LocationQuery, RouteLocation } from '#vue-router'

// The `auth` dialogs `01.auth` strips from a logged-in visitor's URL.
const LOGGED_IN_CLEANUP_AUTH_TYPES = ['signup', 'login', 'reactivate', 'magic-link']

/** Whether `01.auth` bounces a MobilePay OIDC return to `/eid/callback`. */
export function bouncesMobilePayReturn(to: Pick<RouteLocation, 'path' | 'query'>): boolean {
    return to.query.mobilepay === 'true' && to.path !== '/eid/callback'
}

/** Whether `01.auth` sends an anonymous visitor back to the signup's first step, which it does during SSR. */
export function entersSignupPastFirstStep(query: LocationQuery): boolean {
    return query.auth === 'signup' && Number(query.step) !== 1
}

/** Whether `01.auth` strips the `auth` dialog from a logged-in visitor's URL. */
export function stripsLoggedInAuthDialog(query: LocationQuery): boolean {
    const authType = query.auth as string | undefined

    if (!authType || !LOGGED_IN_CLEANUP_AUTH_TYPES.includes(authType)) return false

    return !(authType === 'login' && (query.mitid === 'true' || query.mobilepay === 'true'))
}
